"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    xlinkHref: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(3.12 0 0 -6.24 -262.66 -193.17)",
    gradientUnits: "userSpaceOnUse",
    x1: "90.64",
    x2: "88.63",
    y1: "-33.21",
    y2: "-34.23"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0",
    stopColor: "#9cc339"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: ".65",
    stopColor: "#018dd1"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "1",
    stopColor: "#0071b1"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(6.24 0 0 -3.12 -231.94 -305.04)",
    x1: "40.4",
    x2: "39.4",
    xlinkHref: "#a",
    y1: "-102.29",
    y2: "-104.35"
  }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(6.24 0 0 -3.12 -231.94 -284.16)",
    x1: "40.97",
    x2: "39.97",
    xlinkHref: "#a",
    y1: "-96.71",
    y2: "-98.77"
  }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(3.12 0 0 -6.24 -241.78 -193.17)",
    x1: "85.11",
    x2: "83.1",
    xlinkHref: "#a",
    y1: "-33.78",
    y2: "-34.8"
  }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "e",
    gradientTransform: "matrix(10.68 0 0 -10.68 -196.41 -42.24)",
    x1: "20.73",
    x2: "20.14",
    xlinkHref: "#a",
    y1: "-5.72",
    y2: "-6.32"
  }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "f",
    gradientTransform: "matrix(10.62 0 0 -10.62 -210.09 -44.13)",
    x1: "21.85",
    x2: "21.26",
    xlinkHref: "#a",
    y1: "-5.65",
    y2: "-6.25"
  }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "g",
    gradientTransform: "matrix(10.62 0 0 -10.68 -210.09 -55.53)",
    x1: "21.56",
    x2: "20.97",
    xlinkHref: "#a",
    y1: "-6.4",
    y2: "-7"
  }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "h",
    gradientTransform: "matrix(10.68 0 0 -10.68 -196.42 -55.56)",
    x1: "20.45",
    x2: "19.86",
    xlinkHref: "#a",
    y1: "-6.69",
    y2: "-7.29"
  }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "i",
    gradientTransform: "matrix(4.68 0 0 -5.76 -247.18 -208.62)",
    x1: "57.31",
    x2: "55.87",
    xlinkHref: "#a",
    y1: "-38.77",
    y2: "-39.93"
  }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "j",
    gradientTransform: "matrix(5.28 0 0 -5.82 -237.81 -206.68)",
    x1: "49.26",
    x2: "47.98",
    xlinkHref: "#a",
    y1: "-38.25",
    y2: "-39.4"
  }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "k",
    gradientTransform: "matrix(4.08 0 0 -5.76 -239.98 -208.65)",
    x1: "64.53",
    x2: "62.88",
    xlinkHref: "#a",
    y1: "-39.17",
    y2: "-40.33"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m15.88 14.22a4.66 4.66 0 0 0 -1.51-1.17v-1.34a3.94 3.94 0 0 0 1.37-2.71 2.15 2.15 0 0 0 .09-2.77c.48-1.28 1.1-2.77.84-4.07-.32-1.59-2.59-2.16-4.43-2.16-1.44 0-3.17.36-3.72 1.35a1.75 1.75 0 0 0 -1.27.65c-.8 1.08-.25 2.74.14 4.18a2.19 2.19 0 0 0 .07 2.82 3.89 3.89 0 0 0 1.38 2.7v1.35a4.67 4.67 0 0 0 -1.59 1.26c-3.17 1.2-5 1.91-5.66 2.91a10.37 10.37 0 0 0 -1 4.47c0 .14 6.91.2 13 .18a5.92 5.92 0 0 1 2.32-7.65z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m13.87 19.2 1.25 1.25a3.67 3.67 0 0 1 0-2.49z",
    fill: "url(#a)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m18.67 15.44a3.76 3.76 0 0 1 1.24.21l-1.24-1.24-1.25 1.24a3.77 3.77 0 0 1 1.25-.21z",
    fill: "url(#b)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m18.67 23a3.54 3.54 0 0 1 -1.25-.22l1.25 1.22 1.24-1.25a3.53 3.53 0 0 1 -1.24.25z",
    fill: "url(#c)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.46 19.2-1.24-1.2a3.8 3.8 0 0 1 0 2.49z",
    fill: "url(#d)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m21.47 21.72-.28.29-2 2a4.82 4.82 0 0 0 4.27-4.27z",
    fill: "url(#e)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m16.08 21.91a.27.27 0 0 1 -.12-.09l-2.07-2.07a4.81 4.81 0 0 0 4.25 4.25z",
    fill: "url(#f)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m16 16.59a.4.4 0 0 1 .12-.1l2.06-2.08a4.85 4.85 0 0 0 -4.25 4.27z",
    fill: "url(#g)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m21.19 16.4.28.28 2 2a4.87 4.87 0 0 0 -4.27-4.27z",
    fill: "url(#h)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m17.56 19.8a.84.84 0 0 1 0 .27.77.77 0 0 1 -.17.19 1.08 1.08 0 0 1 -.24.12 1.47 1.47 0 0 1 -.29.05h-1.17v-2.31h1.23a.8.8 0 0 1 .21.05.35.35 0 0 1 .17.15.44.44 0 0 1 .1.19.78.78 0 0 1 0 .21.5.5 0 0 1 -.09.32.54.54 0 0 1 -.24.21.68.68 0 0 1 .31.22.47.47 0 0 1 .18.33zm-1.41-1.32v.58h.6a.26.26 0 0 0 .19-.07.35.35 0 0 0 0-.43.3.3 0 0 0 -.17-.08zm1 1.25a.27.27 0 0 0 0-.12c0-.05 0-.07 0-.09a.39.39 0 0 0 -.1-.08.16.16 0 0 0 -.1 0h-.69v.56h.67a.27.27 0 0 0 .12 0l.1-.07a.31.31 0 0 0 .07-.09s-.11-.09-.11-.11z",
    fill: "url(#i)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m19.51 20.14a.88.88 0 0 1 -.65.26.9.9 0 0 1 -.43-.09 1.16 1.16 0 0 1 -.34-.24 1.58 1.58 0 0 1 -.24-.39 1.17 1.17 0 0 1 -.09-.45.9.9 0 0 1 .09-.46 1.1 1.1 0 0 1 .6-.6.9.9 0 0 1 .46-.09 1 1 0 0 1 .55.14 1.54 1.54 0 0 1 .36.36l-.34.24a.55.55 0 0 0 -.24-.26.56.56 0 0 0 -.33-.1.5.5 0 0 0 -.27.07 1.73 1.73 0 0 0 -.21.17c-.06.08-.1.16-.15.24a1.35 1.35 0 0 0 0 .29 1.1 1.1 0 0 0 0 .31.61.61 0 0 0 .15.24 1.73 1.73 0 0 0 .21.17.62.62 0 0 0 .27.05.77.77 0 0 0 .6-.32v-.16h-.46v-.34h.82v1.22h-.36z",
    fill: "url(#j)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m20.25 20.4v-2.3h.46v1.9h1.17v.38z",
    fill: "url(#k)"
  }));
};

exports["default"] = _default;